<template>
  <MainProjectForm
    v-if="showCreateNewProject"
    v-model="showCreateNewProject"
    no-redirect
    @created:mainProject="createdMainProject"
    :init-project-no="title"
  />
  <SelectBox
    v-else
    @open="getProjects"
    @search="getProjects"
    @option:selected="$emit('option:selected', $event)"
    :options="items"
    :validActivated="validActivated"
    :disabled="disabled"
    :label="label"
    :noLabel="noLabel"
    :value="value"
    :clearable="clearable"
    @input="$emit('input', $event)"
  >
    <template #selected-option="{ item }">
      {{ item.title }}
    </template>
    <template #option="{ item }">
      {{ item.title }}
    </template>
    <template #no-options="{ search }">
      <div class="u-text-align-center">
        <p>
          <small>{{
            $t("mainProjectSearchNotFound", { label: search })
          }}</small>
        </p>
        <div class="u-margin-top">
          <Button variant="primary" @click="createNewProject(search)">
            + {{ $t("mainProject.add") }}
          </Button>
        </div>
      </div>
    </template>
    <template #label-button>
      <Button
        size="xs"
        class="u-margin-left-xsmall"
        variant="light-primary"
        @click="createNewProject(search)"
      >
        + {{ $t("mainProject.add") }}
      </Button>
    </template>
    <template #not-auth v-if="$status.mainProject === 'NOT_AUTHORIZED'">
      <not-auth></not-auth>
    </template>
  </SelectBox>
</template>

<script>
import Requests from "@/services/Requests";
import SelectBox from "../Base/Inputs/SelectBox.vue";
import MainProjectForm from "../MainProjects/MainProjectForm.vue";
import Button from "../Base/Button.vue";
export default {
  components: {
    SelectBox,
    MainProjectForm,
    Button,
  },
  data() {
    return {
      items: [],
      title: "",
      showCreateNewProject: false,
    };
  },
  props: {
    value: {
      default: null,
    },
    clearable: {
      default: false,
      type: Boolean,
    },
    disabled: {
      default: false,
      type: Boolean,
    },
    newCreatable: {
      default: false,
      type: Boolean,
    },
    noLabel: {
      default: false,
      type: Boolean,
    },
    label: {
      type: String,
      required: true,
    },
    validActivated: {
      default: false,
      type: Boolean,
    },
    query: {
      default: () => ({}),
    },
  },
  methods: {
    createdMainProject(data) {
      this.items.unshift(data);
      this.$emit("input", data);
    },
    createNewProject(search) {
      this.title = search;
      this.showCreateNewProject = true;
    },
    /**
     * Makes a request to get all batteries that match the given search query.
     *
     * @param {string} search - search query to send to the API
     * @param {function} loading - function to call when the request is sending or done. Pass true to indicate sending, false to indicate done.
     */
    async getProjects(search, loading) {
      loading(true);

      const response = await Requests.MainProject.GetAll({
        query: { search: search, ...this.query },
      });
      this.$status.mainProject = response.message;
      if (response.message === "OK") {
        this.items = response.data.items;
      } else {
        this.items = [];
      }
      loading(false);
    },
  },
};
</script>

<style></style>
